import produce from 'immer';
export var getInitialState = function () { return ({
    loading: false,
    updating: false,
    error: null,
    datasetRules: [],
    datasetNewRuleId: '',
    groups: [],
    columns: [],
    datasetName: '',
    datasetType: '',
    datasetId: '',
    isNewDatasetId: false,
}); };
function dataSetRuleReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        var _a, _b, _c;
        switch (action.type) {
            case 'LOAD_DATASET_RULES_REQUEST':
                state.loading = true;
                state.error = null;
                state.datasetId = action.datasetId || '';
                break;
            case 'LOAD_DATASET_RULES_SUCCESS':
                state.loading = false;
                state.error = null;
                state.datasetRules = action.rules || [];
                break;
            case 'LOAD_DATASET_RULES_FAILURE':
                state.loading = false;
                state.error = null;
                state.datasetRules = [];
                break;
            case 'CREATE_DATASET_RULE_REQUEST':
                state.loading = true;
                state.error = null;
                break;
            case 'UPDATE_DATASET_RULE_REQUEST':
                state.loading = true;
                state.error = null;
                break;
            case 'CREATE_DATASET_RULE_SUCCESS':
                state.loading = false;
                state.error = null;
                if (action.rule) {
                    state.datasetRules.push(action.rule);
                    state.datasetNewRuleId = action.rule.id;
                }
                break;
            case 'UPDATE_DATASET_RULE_SUCCESS':
                state.loading = false;
                state.error = null;
                action.rule &&
                    state.datasetRules.splice(state.datasetRules.findIndex(function (rule) { var _a; return rule.id === ((_a = action.rule) === null || _a === void 0 ? void 0 : _a.id); }), 1, action.rule);
                break;
            case 'CREATE_DATASET_RULE_FAILURE':
                state.loading = false;
                state.error = null;
                break;
            case 'UPDATE_DATASET_RULE_FAILURE':
                state.loading = false;
                state.error = null;
                break;
            case 'DELETE_DATASET_RULE_REQUEST':
                state.loading = true;
                state.error = null;
                break;
            case 'DELETE_DATASET_RULE_SUCCESS':
                state.loading = false;
                state.error = null;
                state.datasetRules.splice(state.datasetRules.findIndex(function (rule) { return rule.id === action.id; }), 1);
                break;
            case 'DELETE_DATASET_RULE_FAILURE':
                state.loading = false;
                state.error = action.error;
                break;
            case 'LOAD_GROUPS_REQUEST':
                state.loading = true;
                state.error = null;
                break;
            case 'LOAD_GROUPS_SUCCESS':
                state.groups = action.groups || [];
                state.loading = false;
                state.error = null;
                break;
            case 'LOAD_GROUPS_FAILURE':
                state.loading = false;
                state.error = null;
                break;
            case 'LOAD_DATASET_COLUMNS_REQUEST':
                state.loading = true;
                state.error = null;
                break;
            case 'LOAD_DATASET_COLUMNS_SUCCESS':
                state.columns = (_a = action.datasetMeta) === null || _a === void 0 ? void 0 : _a.fields.map(function (_a) {
                    var id = _a.id, name = _a.name, type = _a.type;
                    return ({ id: id, name: name, type: type });
                });
                state.datasetName = ((_b = action.datasetMeta) === null || _b === void 0 ? void 0 : _b.name) || '';
                state.datasetType = ((_c = action.datasetMeta) === null || _c === void 0 ? void 0 : _c.type) || '';
                state.loading = false;
                state.error = null;
                break;
            case 'LOAD_DATASET_COLUMNS_FAILURE':
                state.loading = false;
                state.error = null;
                break;
            case 'IS_NEW_DATASET_RULE_ID':
                state.isNewDatasetId = action.set;
                break;
            default:
                break;
        }
    });
}
export default dataSetRuleReducer;
